import Ramp from '../views/Ramp'

export default Ramp